import { REQUEST_CARD } from "@actions/actionTypes";

export function scanCard(code) {
    return dispatch => {
        dispatch({type: REQUEST_CARD, code})
    }
}